var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 928,
    height: 729,
    viewBox: "0 0 928 729",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M669.875 1.47239C786.127 85.9418 834.03 208.203 829.667 338.063C828.644 368.32 828.136 383.442 832.291 394.117C836.453 404.779 845.461 413.94 863.443 432.225L877.445 446.454C909.067 478.581 924.875 494.634 926.395 515.011C927.914 535.388 914.664 553.631 888.172 590.105L802.643 707.823C776.137 744.289 762.895 762.519 743.041 767.377C723.202 772.209 703.045 762.151 662.697 742L644.854 733.102C621.974 721.668 610.527 715.964 599.172 715.269C587.809 714.587 573.486 719.708 544.813 729.936C423.32 773.31 294.839 762.036 178.633 677.61C-11.0745 539.774 -54.9074 276.686 80.7577 89.9701C97.2326 67.2485 116 46.2768 136.747 27.3534",
    stroke: "#2F2F30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/Bulb.6be2f725fc492457270c052575235962.svg";
export { ForwardRef as ReactComponent };